import React from "react";
import styled from "styled-components";

const PlusButton = ({ onClickHandler }) => {
  return (
    <div>
      <NavbarArrow
        onClick={onClickHandler}
        src="/images/navbar/add.svg"
        alt="add"
      />
    </div>
  );
};

export default PlusButton;

const NavbarArrow = styled.img`
  cursor: pointer;
`;
